export default {
    state: {
        all: [],
        filtered: [],
        selectedContact: {}
    },

    actions: {
        async saveContact({ state, dispatch }, data) {
            data._method = 'PATCH';

            await axios.patch(`/contacts/${data.id}`, data).then((response) => {
                return response;
            }).catch((error) => {
                console.log(error);
            });
        },

        async deleteContact({ state, dispatch }, data) {
            await axios.delete(`/contact/${data.contactId}/detach`, {
                data: data
            }).then((response) => {
                dispatch('removeContact', data.contactId);
            }).catch((error) => {
                console.log(error);
            });
        },

        removeContact({ state }, contactId) {
            state.all = _.filter(state.all, contact => contact.id != contactId);
            state.filtered = _.filter(state.filtered, contact => contact.id != contactId);
        }
    }
};